import styled from "styled-components";
import { color, space } from 'styled-system'
// This will hold background styling.

const Section = styled.div`
  ${color}
  ${space}
`;

export default Section;
